import { DateTime } from 'luxon';
import type { TimeKey } from './types';

// Type guards
export const isValidWidth = (width: string | number | undefined): width is number => {
  return typeof width === 'number';
};

export const isValidX = (x: string | number | undefined): x is number => {
  return typeof x === 'number';
};

// typeguard checking if key is TimeKey
export const isTimeSeriesKey = (key: TimeKey | string): key is TimeKey => {
  return typeof key === 'object' && 'timestamp' in key;
};

// Format key based on whether it's time series or not
export const formatKey = (key: TimeKey | string): string => {
  if (isTimeSeriesKey(key)) {
    const date =
      typeof key.timestamp === 'string'
        ? DateTime.fromISO(key.timestamp, { zone: 'utc' }) // Explicitly set UTC
        : DateTime.fromJSDate(key.timestamp, { zone: 'utc' });

    if (!date.isValid) {
      console.error('Invalid date:', key.timestamp);
      return 'Invalid Date';
    }

    // Format based on grouping
    switch (key.grouping) {
      case 'day':
        return date.toFormat('MMM d');
      case 'month':
        return date.toFormat('MMM, yyyy');
      case 'year':
        return date.toFormat('yyyy');
      default:
        return date.toFormat('MMM yyyy');
    }
  }
  return String(key);
};
